export default __webpack_public_path__ + "static/media/013-warehouse.69532777.svg";